import { useEmbeddedInApp } from "@/contexts/EmbeddedInAppContext";
import { track } from "@/lib/analytics/client";
import { getDiscoverContextProps } from "@/lib/analytics/discoverContext";
import { getClubIdentityProps } from "@/lib/analytics/identity";
import { useSearchParams } from "next/navigation";
import { useCallback } from "react";

export function useClubContactTracking({
  clubId,
  isSpondClub,
}: {
  clubId: string;
  isSpondClub: boolean;
}): { trackContactClick: () => void } {
  const searchParams = useSearchParams();
  const { embeddedInApp } = useEmbeddedInApp();

  const trackContactClick = useCallback(() => {
    track("discover_contact__initiated", {
      ...getClubIdentityProps({ clubId, isSpondClub }),
      ...getDiscoverContextProps({
        searchParams,
        embeddedInApp,
        tab: "clubs",
      }),
    });
  }, [searchParams, embeddedInApp, clubId, isSpondClub]);

  return { trackContactClick };
}
